import {
    useState,
    useEffect,
    useCallback,
    useRef,
    FormEventHandler,
    FormEvent,
} from "react";
import Footer from "../../components/shared/Footer";
import AttorneySelect from "../../components/shared/AttorneySelect";
import AttachExhibits from "./components/AttachExhibits";
import NewCaseDocuments from "./components/NewCaseDocuments";
import NewCaseEFileSummary from "./components/NewCaseEFileSummary";
import NewCaseInformationPanel from "./components/NewCaseInformationPanel";

import { OrganizationService } from "../../services/ClientService";
import { Globals } from "../../helpers/globals";

import * as APIModels from "../../models";

import { useParams } from "react-router-dom";
import {
    SubmissionService,
    eFileService,
} from "../../services/SubmissionService";
import { stringToUTF8String } from "pdfjs-dist/types/src/shared/util";
import {
    ErrorModal,
    ErrorModalProps,
} from "../../components/shared/modals/ErrorModal";
import { Spinner } from "react-bootstrap";
import { PlayCircleFilled } from "@material-ui/icons";
import React from "react";
import EmergencyFileModal from "./modals/EmergencyFileModal";

export default function NewCase() {
    const { id } = useParams<{ id: string }>();
    const { istemplate } = useParams<{ istemplate: string }>();
    const [eFileUpload, seteFileUpload] = useState(
        null as APIModels.UploadNewCase | null
    );
    const [addExhibit, setAddExhibits] = useState(null as null | boolean);
    const [isBatchFile, setIsBatchFile] = useState(
        undefined as boolean | undefined
    );
    const [loading, setLoading] = useState(true);
    const [time, setTime] = useState(Date.now);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const coverSheetNext = useRef<HTMLButtonElement>(null);
    const documentsNext = useRef<HTMLButtonElement>(null);

    const [emergencyFiling, setEmergencyFiling] = useState(false);
    const [showEmergencyFilingModal, setShowEmergencyFilingModal] =
        useState(false);

    const [submitLoading, setSubmitLoading] = useState(false);

    // Error Messages
    const onEMClose = () => {
        setErrorProps({ errorMessage: "", onClose: onEMClose });
        setShowErrorModal(false);
    };

    const [errorProps, setErrorProps] = useState({
        errorMessage: "",
        onClose: onEMClose,
    } as ErrorModalProps);

    useEffect(() => {
        if (errorProps.errorMessage !== "") {
            setShowErrorModal(true);
        } else {
            setShowErrorModal(false);
        }
    }, [errorProps.errorMessage]);

    useEffect(() => {
        eFileService.get({ id: id }).then(
            (resp) => {
                setLoading(false);
                if (resp.successful && resp.data) {
                    //show efile success
                    seteFileUpload({
                        ...resp.data,
                        documents: resp.data.filenames?.map((v) => {
                            return { filename: v, documentType: "" };
                        }),
                    });
                } else {
                    setErrorProps({
                        ...errorProps,
                        errorMessage: resp.errorMessage ?? "",
                    });
                }
            },
            (error) => {
                setLoading(false);
                setErrorProps({
                    ...errorProps,
                    errorMessage: error.message ?? "",
                });
            }
        );
    }, []);

    useEffect(() => {
        console.log("TETETETETETETTETE " + JSON.stringify(eFileUpload));
        if (eFileUpload) {
            eval(
                "$('#checkout-nav-pills-wizard').bootstrapWizard({tabClass: 'nav nav-pills nav-justified'});"
            );
        }
    }, [eFileUpload]);

    const onAttorneySelected = (id: string, name: string) => {
        if (eFileUpload === null) {
            seteFileUpload({ attorneyID: id, attorneyName: name });
        } else {
            seteFileUpload({
                ...eFileUpload,
                attorneyID: id,
                attorneyName: name,
            });
        }
        console.log("NEWCASE ATTORNEYID " + id);
    };
    const onFirmSelected = (id: string, name: string) => {
        seteFileUpload({ ...eFileUpload, attorneyID: "", attorneyName: "" });
        console.log(eFileUpload);
    };

    const onFinishedExhibits = (exhibits: APIModels.Exhibits) => {
        seteFileUpload({ ...eFileUpload, exhibits: exhibits });
    };

    const onClickAddExhibits = () => setAddExhibits(true);

    const onClickNoExhibits = () => {
        setAddExhibits(false);
        if (eFileUpload?.exhibits) {
            const temp = { ...eFileUpload };
            delete temp.exhibits;
            seteFileUpload(temp);
        }
    };

    const clearDocumentTypes = () => {
        for (const doc of eFileUpload!.documents!) {
            doc.documentType = "";
        }
    };

    const onSubmit = () => {
        if (emergencyFiling && !showEmergencyFilingModal) {
            setShowEmergencyFilingModal(true);
        } else {
            setShowEmergencyFilingModal(false);
            setSubmitLoading(true);

            SubmissionService.uploadNewCase({
                id: id,
                body: eFileUpload!,
            })
                .then(
                    (resp) => {
                        console.log(resp);
                        if (resp.successful && resp.data) {
                            //show efile success
                            window.location.href = "/uploads";
                        } else {
                            setErrorProps({
                                ...errorProps,
                                errorMessage: resp.errorMessage ?? "",
                            });
                        }
                    },
                    (error) => {
                        setErrorProps({
                            ...errorProps,
                            errorMessage: error.message ?? "",
                        });
                    }
                )
                .then(() => setSubmitLoading(false));
        }
    };

    useEffect(() => {
        /*
        seteFileUpload({
            ...eFileUpload,
        });
        */
    }, [emergencyFiling]);

    const onCoversheetComplete = (completeCoversheet: APIModels.Coversheet) => {
        seteFileUpload({ ...eFileUpload, coversheet: completeCoversheet });
        setTime(Date.now);
    };

    const onDocumentsComplete = (documents: APIModels.Document[]) => {
        seteFileUpload({ ...eFileUpload, documents: documents });
        documentsNext.current?.click();
        console.log("onAddDocument hit");
        /*
        if (documents.length === 0) {
            setDocumentCheck(false);
        } else {
            seteFileUpload({ ...eFileUpload, documents: documents });

            let typeCheck = true;
            for (const doc of documents) {
                if (doc.documentType == "" || doc.documentType == undefined) {
                    typeCheck = false;
                    break;
                }
            }

            if (
                !eFileUpload?.documents?.find((element) => {
                    return element.documentType === "Complaint";
                })
            ) {
                typeCheck = false;
            }
            setDocumentCheck(typeCheck);
        }
        */
    };

    const onComfirmEmergency = () => {
        onSubmit();
    };

    const onCancelEmergency = () => {
        setShowEmergencyFilingModal(false);
    };

    useEffect(() => {
        if (eFileUpload?.coversheet) {
            coverSheetNext.current?.click();
        }
    }, [eFileUpload?.coversheet, coverSheetNext, time]);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Uploads</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">eFile</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        New Case
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {loading === true ? (
                    <td>
                        <div
                            className="spinner-border text-primary m-2"
                            role="status"
                            style={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                            }}
                        >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </td>
                ) : (
                    <div className="row">
                        {showErrorModal === true ? (
                            <ErrorModal {...errorProps} />
                        ) : null}
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div
                                                id="checkout-nav-pills-wizard"
                                                className="twitter-bs-wizard form-wizard-header"
                                            >
                                                <ul className="twitter-bs-wizard-nav mb-2 nav nav-pills nav-justified">
                                                    <li className="nav-item">
                                                        <a
                                                            href="#attorney-info"
                                                            className="nav-link active"
                                                            style={{
                                                                pointerEvents:
                                                                    "none",
                                                            }}
                                                            data-bs-toggle="tab"
                                                            data-toggle="tab"
                                                        >
                                                            <span className="number">
                                                                01
                                                            </span>
                                                            <span className="d-none d-sm-inline">
                                                                Attorney
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="nav-item">
                                                        <a
                                                            href="#coversheet"
                                                            className="nav-link"
                                                            data-bs-toggle="tab"
                                                            data-toggle="tab"
                                                            style={{
                                                                pointerEvents:
                                                                    "none",
                                                            }}
                                                        >
                                                            <span className="number">
                                                                02
                                                            </span>
                                                            <span className="d-none d-sm-inline">
                                                                Case Information
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            href="#additional-files"
                                                            style={{
                                                                pointerEvents:
                                                                    "none",
                                                            }}
                                                            data-bs-toggle="tab"
                                                            data-toggle="tab"
                                                        >
                                                            <span className="number">
                                                                03
                                                            </span>
                                                            <span className="d-none d-sm-inline">
                                                                Documents
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            href="#exhibit-info"
                                                            style={{
                                                                pointerEvents:
                                                                    "none",
                                                            }}
                                                            data-bs-toggle="tab"
                                                            data-toggle="tab"
                                                        >
                                                            <span className="number">
                                                                04
                                                            </span>
                                                            <span className="d-none d-sm-inline">
                                                                Exhibits
                                                                (Optional)
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            href="#summary"
                                                            style={{
                                                                pointerEvents:
                                                                    "none",
                                                            }}
                                                            data-bs-toggle="tab"
                                                            data-toggle="tab"
                                                        >
                                                            <span className="number">
                                                                05
                                                            </span>
                                                            <span className="d-none d-sm-inline">
                                                                Summary
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                                <div className="tab-content twitter-bs-wizard-tab-content">
                                                    <div
                                                        className="tab-pane active"
                                                        id="attorney-info"
                                                    >
                                                        <div>
                                                            <h4 className="header-title">
                                                                Attorney
                                                                Information
                                                            </h4>
                                                            <p className="sub-header">
                                                                Please select
                                                                the attorney
                                                                filing the
                                                                pleadings.
                                                            </p>
                                                        </div>
                                                        <AttorneySelect
                                                            onAttorneySelected={
                                                                onAttorneySelected
                                                            }
                                                            onFirmSelected={
                                                                onFirmSelected
                                                            }
                                                        />
                                                        <ul className="pager wizard list-inline mt-2">
                                                            <li className="list-inline-item">
                                                                <a
                                                                    href="/uploads"
                                                                    className="btn btn-secondary"
                                                                >
                                                                    <i className="mdi mdi-arrow-left"></i>{" "}
                                                                    Back to
                                                                    Upload
                                                                </a>
                                                            </li>
                                                            <li
                                                                className="next list-inline-item float-end"
                                                                style={{
                                                                    pointerEvents:
                                                                        eFileUpload?.attorneyID
                                                                            ? "auto"
                                                                            : "none",
                                                                }}
                                                            >
                                                                {!eFileUpload?.attorneyID ||
                                                                eFileUpload?.attorneyID ==
                                                                    "" ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success disabled"
                                                                        disabled
                                                                    >
                                                                        Next
                                                                        <i className="mdi mdi-arrow-right"></i>{" "}
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success"
                                                                    >
                                                                        Next
                                                                        <i className="mdi mdi-arrow-right"></i>{" "}
                                                                    </button>
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div
                                                        className="tab-pane"
                                                        id="coversheet"
                                                    >
                                                        <NewCaseInformationPanel
                                                            onComplete={
                                                                onCoversheetComplete
                                                            }
                                                            coversheet={
                                                                eFileUpload?.coversheet ??
                                                                new APIModels.Coversheet()
                                                            }
                                                            attorneyId={
                                                                eFileUpload?.attorneyID ??
                                                                ""
                                                            }
                                                        />
                                                        <ul className="pager wizard list-inline mt-2">
                                                            <li className="previous list-inline-item">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                >
                                                                    <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                    Back to
                                                                    Attorney
                                                                </button>
                                                            </li>

                                                            <li
                                                                className="next list-inline-item float-end"
                                                                style={{
                                                                    pointerEvents:
                                                                        eFileUpload?.coversheet
                                                                            ? "auto"
                                                                            : "none",
                                                                }}
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success"
                                                                    disabled={
                                                                        !eFileUpload?.coversheet
                                                                    }
                                                                    ref={
                                                                        coverSheetNext
                                                                    }
                                                                    style={{
                                                                        display:
                                                                            "none",
                                                                    }}
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div
                                                        className="tab-pane"
                                                        id="additional-files"
                                                    >
                                                        <div>
                                                            <h4 className="header-title">
                                                                Documents
                                                            </h4>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-12">
                                                                <NewCaseDocuments
                                                                    callback={
                                                                        onDocumentsComplete
                                                                    }
                                                                />
                                                            </div>
                                                            <div />
                                                        </div>

                                                        <ul className="pager wizard list-inline needs-validation mt-2">
                                                            <li className="previous list-inline-item">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                >
                                                                    <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                    Back to
                                                                    Coversheet
                                                                </button>
                                                            </li>

                                                            <li className="next list-inline-item float-end">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success"
                                                                    ref={
                                                                        documentsNext
                                                                    }
                                                                >
                                                                    Next
                                                                    <i className="mdi mdi-arrow-right"></i>{" "}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div
                                                        className="tab-pane"
                                                        id="exhibit-info"
                                                    >
                                                        <div>
                                                            <h4 className="header-title">
                                                                Exhibit
                                                            </h4>

                                                            <p className="sub-header">
                                                                Do you need to
                                                                attach
                                                                additional
                                                                exhibits to your
                                                                filing?
                                                            </p>

                                                            <p className="sub-header">
                                                                EXHIBITS DO NOT
                                                                ATTACH TO BATCH
                                                                FILES
                                                            </p>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary"
                                                                    onClick={
                                                                        onClickAddExhibits
                                                                    }
                                                                >
                                                                    Yes
                                                                </button>
                                                                &nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger"
                                                                    onClick={
                                                                        onClickNoExhibits
                                                                    }
                                                                >
                                                                    No
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-12">
                                                                {addExhibit && (
                                                                    <AttachExhibits
                                                                        callback={
                                                                            onFinishedExhibits
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                            <div />
                                                        </div>
                                                        <ul className="pager wizard list-inline mt-2">
                                                            <li className="previous list-inline-item">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                >
                                                                    <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                    Back to
                                                                    Documents
                                                                </button>
                                                            </li>
                                                            {addExhibit ===
                                                                false ||
                                                            (addExhibit ==
                                                                true &&
                                                                eFileUpload?.exhibits !=
                                                                    undefined &&
                                                                eFileUpload
                                                                    ?.exhibits
                                                                    .filenames!
                                                                    .length !=
                                                                    0) ? (
                                                                <li className="next list-inline-item float-end">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success"
                                                                    >
                                                                        Next
                                                                        <i className="mdi mdi-arrow-right"></i>{" "}
                                                                    </button>
                                                                </li>
                                                            ) : (
                                                                <li
                                                                    className="next list-inline-item float-end"
                                                                    style={{
                                                                        pointerEvents:
                                                                            "none",
                                                                    }}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success disabled"
                                                                        disabled={
                                                                            true
                                                                        }
                                                                    >
                                                                        Next
                                                                        <i className="mdi mdi-arrow-right"></i>{" "}
                                                                    </button>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                    <div
                                                        className="tab-pane"
                                                        id="summary"
                                                    >
                                                        <div>
                                                            <h4 className="header-title">
                                                                Summary
                                                            </h4>
                                                            <p className="sub-header">
                                                                Review the
                                                                information
                                                                below and verify
                                                                for accuracy.
                                                            </p>
                                                        </div>
                                                        <div>
                                                            {" "}
                                                            <NewCaseEFileSummary
                                                                upload={
                                                                    eFileUpload ??
                                                                    {}
                                                                }
                                                                setUpload={
                                                                    seteFileUpload
                                                                }
                                                            />
                                                        </div>
                                                        <ul className="pager wizard list-inline mt-2">
                                                            <li className="previous list-inline-item">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                >
                                                                    <i className="mdi mdi-arrow-left me-1"></i>{" "}
                                                                    Back to
                                                                    Exhibits
                                                                </button>
                                                            </li>

                                                            <li
                                                                className="next list-inline-item"
                                                                style={{
                                                                    position:
                                                                        "relative",

                                                                    left: "81%",
                                                                }}
                                                            >
                                                                <button
                                                                    onClick={() =>
                                                                        onSubmit()
                                                                    }
                                                                    className="btn btn-success"
                                                                >
                                                                    {submitLoading && (
                                                                        <>
                                                                            <Spinner
                                                                                as="span"
                                                                                animation="border"
                                                                                size="sm"
                                                                                role="status"
                                                                                aria-hidden="true"
                                                                            />
                                                                            &nbsp;
                                                                            Loading...
                                                                        </>
                                                                    )}
                                                                    {!submitLoading && (
                                                                        <>
                                                                            <PlayCircleFilled />{" "}
                                                                            Submit
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                        <div
                                                            className="form-check"
                                                            style={{
                                                                position:
                                                                    "relative",

                                                                top: "50%",
                                                                left: "92%",
                                                                wordBreak:
                                                                    "break-word",
                                                                whiteSpace:
                                                                    "break-spaces",
                                                                maxWidth:
                                                                    "150px",
                                                            }}
                                                        >
                                                            <EmergencyFileModal
                                                                show={
                                                                    showEmergencyFilingModal
                                                                }
                                                                onCancelEmergency={
                                                                    onCancelEmergency
                                                                }
                                                                onConfirmEmergency={
                                                                    onComfirmEmergency
                                                                }
                                                            ></EmergencyFileModal>
                                                            <input
                                                                className="form-check-input"
                                                                id="ckEmergency"
                                                                type="checkbox"
                                                                checked={
                                                                    emergencyFiling
                                                                }
                                                                onChange={(
                                                                    event
                                                                ) => {
                                                                    setEmergencyFiling(
                                                                        event
                                                                            .currentTarget
                                                                            .checked
                                                                    );
                                                                    seteFileUpload(
                                                                        {
                                                                            ...eFileUpload,
                                                                            emergency:
                                                                                event
                                                                                    .currentTarget
                                                                                    .checked,
                                                                        }
                                                                    );
                                                                }}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="ckOverride"
                                                            >
                                                                Is this an
                                                                Emergency
                                                                Filing?
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
}
